import { Button } from '@jouzen/ecom-components/v3/Button';
import { Typography } from '@jouzen/ecom-components/v3/Typography';
import { cx } from 'class-variance-authority';
import { useTranslations } from 'next-intl';
import type { MessageKey } from 'types/LocaleMessageKey';

import Motion from '@/app/components/Motion';

export interface LandingPageScrollFeatureTabProps {
  readonly actionLabel?: MessageKey | undefined;
  readonly actionOnClick?: () => void;
  readonly copy: MessageKey;
  readonly image: string;
  readonly imageAlt: MessageKey;
  readonly title: MessageKey;
}

interface LandingPageScrollFeatureTabsProps {
  readonly activeTab: number;
  readonly tabs: LandingPageScrollFeatureTabProps[];
}

const LandingPageScrollFeatureTabs = ({
  activeTab,
  tabs,
}: LandingPageScrollFeatureTabsProps) => {
  const t = useTranslations();

  return (
    <section>
      {tabs.map((tab, index) => (
        <div
          key={tab.title}
          className="py-1"
          data-cy={`landing-page-scroll-feature-tab`}
        >
          <span
            className={cx({
              'text-neutral-400': activeTab !== index,
            })}
          >
            <Typography
              className="w-4/5 text-2xl font-normal tracking-tighter"
              color="inherit"
              Element="h3"
              variant="h5"
            >
              {t(tab.title)}
            </Typography>
          </span>
          <Motion
            animate={{
              height: activeTab === index ? 'auto' : 0,
              opacity: activeTab === index ? 1 : 0,
            }}
            className="overflow-hidden"
            transition={{ duration: 0.2, ease: 'easeInOut' }}
          >
            <Typography
              Element="p"
              color="inherit"
              className="mt-1 max-w-[450px] text-body-sm"
            >
              {t(tab.copy)}
            </Typography>
            {tab.actionLabel && (
              <Button
                className="my-4"
                variant="secondary-dark"
                size="small"
                onClick={tab.actionOnClick}
              >
                {t(tab.actionLabel)}
              </Button>
            )}
          </Motion>
        </div>
      ))}
    </section>
  );
};

export default LandingPageScrollFeatureTabs;
